import axios, { AxiosResponse } from "axios";
import { FlaskReq, GatewayReq } from "../Request";

export type Fetcher = <
  ResponseData = any,
  Response extends AxiosResponse = AxiosResponse<ResponseData>
>(
  url: any,
  config: any
) => Promise<Response>;

export const axiosFetcher: Fetcher = function <T = any, R = any>(url, config) {
  return axios.get<T, R>(url, config);
};

export const fetcher = function <E = any, T = any, R = any>(request, url, config) {
  return (request(
    {
      ...config,
      method: "get",
      url
    },
    {
      showMessage: false
    }
  ) as any) as Promise<R>;
};


export const flaskFetcher: Fetcher = function <T = any, R = any>(url, config) {
  return fetcher(FlaskReq, url, config)
};

export const gatewayFetcher: Fetcher = function <T = any, R = any>(url, config) {
  return fetcher(GatewayReq, url, config)
};
